import { Component, OnChanges, Input, SimpleChanges, Output, EventEmitter } from "@angular/core";
import { RailcarCPdNotificationData } from './railcar-cpd-data.model';

@Component({
	selector: 'notification-railcar-cpd',
	templateUrl: 'notification-railcar-cpd.component.html'
})

export class NotificationRailcarCPd implements OnChanges {
	@Input() data: RailcarCPdNotificationData;
	@Input() nightMode: boolean;
	@Output() cpDateChanged = new EventEmitter<any>()
	public currentDate = new Date();

	constructor() {	}

	ngOnChanges(changes: SimpleChanges) {
		if (!!changes.data && !!changes.data.currentValue) {
			this.data = new RailcarCPdNotificationData(changes.data.currentValue);
		}
	}

	dateChanged(): void {
		this.cpDateChanged.emit({'value': this.data.arrivalDate, 'notificationId': this.data.notificationId, 'category': this.data.notificationCategory});
	}
}
